var map = {
	"./autocomplete-dropdown/template.hbs": 3993,
	"./mw-audio-options-dropdown/template.hbs": 86261,
	"./mw-chat-info-member-dropdown/template.hbs": 81392,
	"./mw-chat-options-dropdown/template.hbs": 75517,
	"./mw-document-options-dropdown/template.hbs": 93184,
	"./mw-emoji-list-popup/template.hbs": 92358,
	"./mw-emoji-name-popup/template.hbs": 41517,
	"./mw-emoji-picker/template.hbs": 37856,
	"./mw-emoji-sender-dropdown/template.hbs": 30062,
	"./mw-giphy-picker/template.hbs": 11470,
	"./mw-main-header-dropdown/template.hbs": 17273,
	"./mw-notifications-dropdown/template.hbs": 79902,
	"./mw-profile-popup/template.hbs": 65610,
	"./mw-simple-emoji-picker/template.hbs": 67530,
	"./mw-stickers-picker/generate-sticker/template.hbs": 33687,
	"./mw-stickers-picker/template.hbs": 56741,
	"./mw-tooltip-popup/template.hbs": 12352,
	"./targets-dropdown/template.hbs": 38665
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 43446;
module.exports = webpackAsyncContext;